import React from 'react';
import { twMerge } from 'tailwind-merge';
import { CheckIcon } from '@heroicons/react/20/solid';

export interface SelectedCheckBadgeProps {
  className?: string;
}

/**
 * Checkmark badge in the top-right corner of a selected option of the classic
 * layout. The badge is decoration: the button it sits in already conveys the
 * selection, so it stays out of the accessibility tree. Its parent needs a
 * `relative` position, unless the caller places it in the flow with `className`.
 */
export function SelectedCheckBadge({ className }: Readonly<SelectedCheckBadgeProps>) {
  return (
    <span
      aria-hidden="true"
      data-testid="selected-check-badge"
      className={twMerge(
        'absolute left-2 top-2 flex h-5 w-5 items-center justify-center rounded-full bg-neutral-100 text-white',
        className,
      )}
    >
      <CheckIcon className="h-3.5 w-3.5" />
    </span>
  );
}
